import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApiConfig from '../../config/ApiConfig';
import { crypt, formatDate, getNewParameters, getObjectSubset, getParameters, handleTheImageOpen } from '../../lib/helper';
import { imageListingItemsSelector } from '../../redux/image';
import { imagesByVisibleskKeywords } from '../../Services/imageApis';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import EditImageDetailModal from '../Modals/EditImageDetailModal';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SuspendImageModal from '../Modals/SuspendImageModal';
import MatTable from '../Tables/MatTable';
import AllFilters from '../Order/AllFilters';
import { getListOfImageKeywords } from '../../Services/keywordsApis';
import ViewImage from '../Modals/ViewImage ';


const column = [
  {
    label: 'Image',
    id: 'image_url',
    format: (columnData) => (
      <span
        style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
        onClick={() => {

        }}
      >
        <img style={{ maxWidth: 200, maxHeight: 200 }} src={`${columnData}`} />

      </span>
    ),
    onClick: handleTheImageOpen,
    numeric: 'center',

  },
  {
    label: 'Image ID',
    id: 'Name',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap', }} onClick={() => {
      }} >
        {columnData}
      </span>
    ),
  },
  {
    label: 'Rank',
    id: 'rank',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData}
      </span>
    ),
  },
  {
    label: 'Rank1',
    id: 'rank1',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData}
      </span>
    ),
  },

  {
    label: 'Contributor',
    id: 'is_contributor',
    format: (columnData, rowIndex, formatCallback, func, errors, row) => (<span style={{ display: 'inline-block' }}>
      <span style={{ display: 'inline-block', whiteSpace: "nowrap" }}><Typography variant='span' className='fontWeight600'>IsContributor:</Typography> {columnData == 1 ? 'yes' : 'No'}</span><br />
      <span style={{ display: 'inline-block', whiteSpace: "nowrap" }}><Typography variant='span' className='fontWeight600'>Name:</Typography> {row?.contributor}</span>
    </span>)
  },

  {
    label: 'Shoot ID',
    id: 'shootid',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || 'N/A'}
      </span>
    ),
  },

  {
    label: 'Sold Count',
    id: 'sold_count',
    format: (columnData) => (
      <span style={{ display: 'block', textAlign: "center", whiteSpace: 'nowrap' }}>
        {columnData}
      </span>
    ),
    nextLine: true,
  },

  {
    label: 'Suspended Date',
    id: 'suspendate',
    format: (columnData) => (
      <>
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
          {formatDate(columnData, 'dd/mm/yyyy')}
        </span>

      </>
    ),
    nextLine: true,
  },
];

function SearchImageByKeyword() {
  const [tableListing, setTableListing] = useState([]);
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const [imageEditModal, setImageEditModal] = useState(false);
  const [imageSuspendModal, setImageSuspendModal] = useState(false);
  const [imageKeyword, setImageKeyword] = useState(false);
  const [imageShowModel, setImageShowModel] = useState(false);
  const [editImageData, setEditImageData] = useState({});
  const { loading, allImagesByKeyword } = useSelector(imageListingItemsSelector);
  const dispatch = useDispatch();
  const [imageOpenData, setImageOpenData] = useState(null);
  const [keywordForTheChoosenImage, setKeywordForTheChoosenImage] = useState([]);
  const [limit, setLimit] = useState(20);
  const navigate = useNavigate();
  const location = useLocation();
  const [filtersArray, setFiltersArray] = useState([
    {
      label: 'From Date',
      id: 'start_date',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;

          const startDate = e.target.value;
          const endDate = newState[1].value;
          if (endDate && startDate > endDate) {
            newState[1].value = '';
          }

          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'To Date',
      id: 'end_date',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;

          const endDate = e.target.value;
          const startDate = newState[0].value;
          if (startDate && endDate < startDate) {
            console.warn('End date cannot be before start date');
          }

          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'Search Text',
      id: 'search',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e?.target?.value?.trim();
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: {},
      isVisible: true,
    },
    {
      label: 'Sort By',
      id: 'sortBy',
      type: 'select',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e?.target?.value;
          return newState;
        });
      },
      style: {},
      dataArr: [
        {
          label: 'Select',
          value: '',
        },
        {
          label: 'Sold Count',
          value: 'sold_count',
        },
        {
          label: 'Rank1',
          value: 'rank1',
        },
      ],
      props: {},
      isVisible: true,
    },
  ]);

  const handleFilter = (data, allDatavalues, dataWithValue) => {
    const searchText = filtersArray[2]?.value || '';
    const sortBy = filtersArray[3]?.value || '';

    getListing(
      {
        page: String(1),
        search: searchText,
        sortBy: sortBy,
        ...dataWithValue,
      },
      true,
    );
    setAllParams({
      page: String(1),
      search: searchText,
      sortBy: sortBy,
      ...dataWithValue,
    });
  };

  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, 'tab', 'page');
    setAllParams(data);
    setFiltersArray((prevState) => {
      let newState = [...prevState];
      // Clear all filter values
      newState.forEach(filter => {
        filter.value = '';
      });
      return newState;
    });
  };

  const handleModal = (value = false) => {
    setImageEditModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const handleSuspendModal = (value = false) => {
    setImageSuspendModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const handleImageModal = (value = false) => {
    setImageShowModel(value);
  };

  const handleImageKeywordModal = (value = false) => {
    setImageKeyword(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      ...allParams,
      ...params,
    };
    if (payload.sortBy === '') {
      delete payload.sortBy;
    }
    if (payload?.start_date) {
      payload['start_date'] =
        formatDate(payload?.start_date, 'yyyy-mm-dd') + '  00:00:00';
    }
    if (payload?.end_date) {
      payload['end_date'] =
        formatDate(payload?.end_date, 'yyyy-mm-dd') + '  23:59:59';
    }
    dispatch(imagesByVisibleskKeywords(payload));
    setPage(Number(payload.page));
    setEditImageData({});
  };

  useEffect(() => {
    getListing();
  }, []);

  useEffect(() => {
    let params = getParameters()
    setAllParams(params)
    if (params.sortBy) {
      setFiltersArray((prevState) => {
        let newState = [...prevState];
        newState[3].value = params.sortBy;
        return newState;
      });
    }
  }, [location?.search]);

  useEffect(() => {
    let data = getNewParameters(allParams)
    if (data?.search !== location.search) {
      navigate(data.newUrl, { replace: false })
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page))
      }
    }
    getListing();
  }, [allParams])

  const handleAllKeywordsForimage = async (data) => {
    let response = await getListOfImageKeywords(data?.Name);
    if (response?.status == 200) {
      setKeywordForTheChoosenImage(response?.data);
      handleImageKeywordModal(true)
    }
  }

  const handleAllFunctions = (data) => {
    setEditImageData(data);
    handleAllKeywordsForimage(data);
  }

  const imageActionBody = (data) => {
    setImageOpenData(data);
    setImageShowModel(true);
  }

  //making data format for table input
  useEffect(() => {
    if (allImagesByKeyword?.items?.images?.length >= 0) {
      let data = allImagesByKeyword?.items?.images?.map((item) => {
        return {
          image_url: `${ApiConfig.BASE_IMAGE_URL}${item?.shootid}/${item?.rank}-${item?.Name}.jpg`,
          Name: item?.Name,
          contributor: item,
          rank: item.rank, //=>edit
          rank1: item.rank1,
          shootid: item.shootid,
          is_contributor: item?.is_contributor,
          pricing: item.pricing, //=>edit
          suspendate: item.suspendate,
          createddate: item?.createddate,
          contributor: item.contributor,
          modelreleaseid: item?.modelreleaseid,
          available: item.available,
          type: item.type, //=>edit dropdown value [I, S]
          createddate: item.createdAt,
          imgstatus: item.imgstatus,
          suspend: item.imgstatus,
          rank1: item.rank1, //=>edit
          keywords: item.Name, //=>edit
          sold_count: item.sold_count,
          is_star: item?.is_star,
          watermark: item?.watermark,
          sold_count: item?.sold_count,
        };
      });
      setTableListing(data);
    }
  }, [allImagesByKeyword.items]);

  const actionBody = (data) => {
    return (
      <>
        <div style={{ display: 'flex' }}>
          <Link className='textDecoration-none' to={`${crypt(ApiConfig.REACT_APP_SALT + 'image_name', data?.Name)}`} target={'_blank'} >
            <CustomButton className="buttonDense" onClick={() => {
            }} sx={{ bgcolor: 'buttonInfo.main' }}>Keywords</CustomButton>
          </Link>
          <CustomButton className="buttonDense" onClick={() => {
            handleSuspendModal(true);
            setEditImageData(data);
          }}>Suspend</CustomButton>
          <CustomButton
            className="buttonDense"
            sx={{
              fontSize: '12px',
              bgcolor: 'buttonSecondary.main',
              color: 'buttonSecondary.contrastText',
            }}
            onClick={() => {
              handleModal(true);
              setEditImageData(data);
            }}
          >
            Edit
          </CustomButton>
        </div>
      </>
    );
  };

  return (
    <>
      <MatTable
        loading={allImagesByKeyword?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            sortBy: '',
            ...getObjectSubset(data, 'start_date', 'end_date', 'sortBy'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date', 'sortBy'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        action={actionBody}
        imageActionBody={imageActionBody}
        page={page}
        perPage={limit}
        showPageLimit={true}
        pageLimitArray={[20, 50, 100, 200]}
        handleChangePageLimit={(e) => {
          setLimit(e.target.value);
          setAllParams({
            ...allParams,
            page: String('1'),
            limit: Number(e.target.value),
            sortBy: allParams.sortBy || '',
          });
        }}
        total={allImagesByKeyword?.items?.totalCount || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
            sortBy: allParams.sortBy || '',
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
            sortBy: allParams.sortBy || '',
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        toolbarEnable={true}
        pagination={true}
        filtersUrlData={allParams || {}}

        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
          // hasAddNew={true}
          // handleAddNewModal={handleAddNewItem}
          // addText={'Bulk Suspend'}
          // handleAddtionalButton={handleAdditionButton}
          // addionalButton={true}
          // addtionalText="Checkout"
          />
        )}
        disableSearch
      />
      <EditImageDetailModal
        open={imageEditModal}
        handleOpen={handleModal}
        data={editImageData}
        getListing={getListing}
      />
      <SuspendImageModal
        open={imageSuspendModal}
        handleOpen={handleSuspendModal}
        data={editImageData}
        getListing={getListing}
      />

      <>{imageShowModel &&
        <ViewImage
          open={imageShowModel}
          handleOpen={handleImageModal}
          data={imageOpenData}
        />}</>

    </>
  );
}

export default SearchImageByKeyword;